// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null,
  data2: [],
  total2: 1,
  from2: 0,
  to2: 0,
  params2: {},
}

const memberVerificationDatas = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_MEMBER_VERIFICATION_DATA':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }

      case 'GET_DATA_MEMBER2_VERIFICATION_DATA':
      return {
        ...state,
        data2: action.data,
        total2: action.totalPages,
        params2: action.params,
        from2: action.from,
        to2: action.to,
      }

    case 'GET_MEMBER_VERIFICATION_DATA':
      return { ...state, selectedData: action.selectedData }
    case 'ADD_MEMBER_VERIFICATION_DATA':
      return { ...state }
    case 'EDIT_MEMBER_VERIFICATION_DATA':
      return { ...state }
    case 'DELETE_MEMBER_VERIFICATION_DATA':
      return { ...state }
    default:
      return { ...state }
  }
}
export default memberVerificationDatas
